import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/services_/cyber-security_/montclair")({
  beforeLoad: () => {
    throw redirect({ href: "/services/cyber-security", statusCode: 301 });
  },
});
